export default "ㅏ\nㅑ\nㅓ\nㅕ\nㅗ\nㅛ\nㅜ\nㅠ\nㅡ\nㅣ\nㄱ\nㄴ\nㄷ\nㄹ\nㅁ\nㅂ\nㅅ\nㅇ\nㅈ\nㅊ\nㅋ\nㅌ\nㅍ\nㅎ"